import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Item from './components/Item'

import acl from '../../../../../../services/acl'

import './style.scss'

@acl
export default class Menu extends Component {
    static propTypes = {
        configuration: PropTypes.array.isRequired,
        hasRights: PropTypes.func.isRequired,
    }

    render() {
        const { configuration, hasRights } = this.props

        return (
            <div className={'user-profile-menu'}>
                {_.map(configuration, (item) => (
                    <Item key={item.key} path={[item.key]} item={item} hasRights={hasRights} />
                ))}
            </div>
        )
    }
}
